import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './components/pages/Home';
import { Work } from './components/pages/Work';
import { About } from './components/pages/About';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route element={<Layout data-id="element-3" />} data-id="element-2">
          <Route path="/" element={<Home data-id="element-5" />} data-id="element-4" />
          <Route path="/work" element={<Work data-id="element-7" />} data-id="element-6" />
          <Route path="/about" element={<About data-id="element-9" />} data-id="element-8" />
        </Route>
      </Routes>
    </BrowserRouter>;
}